
const apiConfig = {
    //Local
   // apiUrl: 'https://localhost:7007/api/',
    //Live

    //DEV
    apiUrl: 'https://arcm-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

